import { z } from "zod";

import { CAMPAIGN_ASSIGNED_BY } from "@signalist/shared-types";

/**
 * A lead's campaign as the list table reads it: its own campaign config override, the campaign it
 * holds (preassigned or enrolled), why it holds it (PREC-4219: a routing rule, the list's default,
 * or a person) and the routing rule behind a RULE. The API stores the reason on `list_person`
 * (`campaignAssignedBy`, `campaignRoutingRuleId`) and the table's row fetch returns every column.
 */
export const ListPersonCampaignSchema = z.object({
	campaignConfig: z.any().nullable().optional(),
	campaignId: z.string().nullable().optional(),
	campaignAssignedBy: z.enum(CAMPAIGN_ASSIGNED_BY).nullable().optional(),
	campaignRoutingRuleId: z.number().nullable().optional(),
});

export type ListPersonCampaign = z.infer<typeof ListPersonCampaignSchema>;
